import AbstractJourney from './abstract-journey.model'
import cloneDeep from 'lodash.clonedeep'

export default class Shuttle extends AbstractJourney {
  constructor(journey) {
    super(AbstractJourney.SHUTTLE)
    this.journey = journey
  }

  static restructured(journey) {
    /*
    Se in una NAVETTA le destinazioni sono uguali
    e la merce trasportata in ANDATA e RITORNO è uguale per tipo, aspetto, pericolosità e peso,
    il viaggio non necessita di ristrutturazione.

    In tutti gli altri casi, la NAVETTA và ristrutturata come due viaggi NAVETTA:
    - ANDATA: Con la merce Raccolta
    - RITORNO: Con la merce Distribuita

    I Km percorsi saranno suddivisi equamente tra i due viaggi NAVETTA.
    Il numero di viaggi resterà invariato.

    Se non è stata trasportata merce in ANDATA o RITORNO, il corrispondente viaggio sarà a vuoto.
    */
    const { origin, destination, goods, num_journeys } = journey
    const halfNumJourneys = num_journeys / 2

    const samePlaces = origin.id === destination.id
    const sameGoods =
      goods[0].type === goods[1].type &&
      goods[0].dangerous_type === goods[1].dangerous_type &&
      goods[0].aspect === goods[1].aspect &&
      goods[0].weight === goods[1].weight

    if (samePlaces && sameGoods) {
      let j = cloneDeep(journey)
      return [cloneDeep(j)]
    }

    const journeyA = cloneDeep(journey)
    const journeyR = cloneDeep(journey)

    if (!sameGoods) {
      journeyA.goods[0] = cloneDeep(journey.goods[0])
      journeyA.goods[1] = cloneDeep(journey.goods[0])
      journeyR.goods[0] = cloneDeep(journey.goods[1])
      journeyR.goods[1] = cloneDeep(journey.goods[1])

      if (journey.goods[0].is_empty) {
        journeyA.goods[0].is_empty = true
        journeyA.is_empty = true
        journeyA.distance.loaded = 0
        journeyR.distance.empty = 0
        journeyA._type = Shuttle._ROUND_OR_SHUTTLE_EMPTY
      } else if (journey.goods[1].is_empty) {
        journeyR.goods[0].is_empty = true
        journeyR.is_empty = true
        journeyR.distance.loaded = 0
        journeyA.distance.empty = 0
        journeyR._type = Shuttle._ROUND_OR_SHUTTLE_EMPTY
      }
    }

    // journeyA.via = `${via}a`
    journeyA.num_journeys = halfNumJourneys

    // journeyR.via = `${via}r`
    journeyR.origin = destination
    journeyR.destination = origin
    journeyR.num_journeys = halfNumJourneys

    return [journeyA, journeyR]
  }

  static getDestination(journey) {
    return journey.origin
  }
}
